// getConfigDetails.js
import { getPartnerDetails } from '../utils/helper'

const getConfigDetails = Object.freeze({
  ENV: process.env.REACT_APP_ENV,

  // Local URLs
  customerLocalUrl: process.env.REACT_APP_CUSTOMER_LOCAL_URL,
  adminLocalUrl: process.env.REACT_APP_ADMIN_LOCAL_URL,

  // Base URLs
  baseURL: process.env.REACT_APP_API_BASE_URL,
  adminUrl: process.env.REACT_APP_ADMIN_URL,
  checkInUrl: process.env.REACT_APP_CHECKIN_URL,
  transientURL: process.env.REACT_APP_TRANSIENT_URL,
  portalURL: process.env.REACT_APP_PORTAL_URL,
  customerPortalURL: process.env.REACT_APP_CUSTOMER_PORTAL_URL,

  //rev admin
  revadminUrl: process.env.REACT_APP_API_BASE_URL || null,
  revcheckInUrl: process.env.REACT_APP_REV_CHECKIN_URL || null,
  revtransientURL: process.env.REACT_APP_REV_TRANSIENT_URL || null,
  revportalURL: process.env.REACT_APP_REV_CUSTOMERPORTAL_URL || null,
  revcustomerPortalURL: process.env.REACT_APP_REV_CUSTOMERPORTAL_URL || null,

  // Runtime (dynamic)
  get FACILITY_ID() {
    const source = process.env.REACT_APP_FACILITY_SOURCE

    if (source === 'runtime') {
      return getPartnerDetails()?.facilities?.[0]?.id ?? null
    }

    if (source === 'static') {
      const id = process.env.REACT_APP_FACILITY_ID ?? null
      return id ? Number(id) : null
    }

    return null
  },

  get PARTNER_ID() {
    return getPartnerDetails()?.clients?.partner_id ?? null
  },

  get CLIENT_ID() {
    return getPartnerDetails()?.clients?.id ?? null
  },

  get CLIENT_SECRET() {
    return getPartnerDetails()?.clients?.secret ?? ''
  },

  // Payment scripts
  googlePayScript: process.env.REACT_APP_GOOGLE_PAY_SCRIPT,
  payButtonScript: process.env.REACT_APP_PAY_BUTTON_SCRIPT,
  applePayScript: process.env.REACT_APP_APPLE_PAY_SCRIPT,

  applePayDTScript: process.env.REACT_APP_APPLE_PAY_DT_SCRIPT,
  payButtonDTScript: process.env.REACT_APP_PAY_BUTTON_DT_SCRIPT,
  applePayHLScript: process.env.REACT_APP_APPLE_PAY_HL_SCRIPT,

  googlePayDTScript: null,
  googlePayHLScript: null,
  payButtonHLScript: null,
  chiperKey: process.env.REACT_APP_CHIPER_KEY
})

export default getConfigDetails
